export enum HrResearchEquityReason {
  'IndividualPerformance' = 'IndividualPerformance',
  'TeamContribution' = 'TeamContribution',
  'AchievementOfKeyObjectivesKPis' = 'AchievementOfKeyObjectivesKPis',
  'CriticalSkillsOrRoleScarcity' = 'CriticalSkillsOrRoleScarcity',
  'PotentialSuccessionCandidate' = 'PotentialSuccessionCandidate',
  'ProbabilityOfTurnover' = 'ProbabilityOfTurnover'
}
